<template>
</template>
<script>
    export default {
        mounted() {
            if(this.background !== ''){
            	$.backstretch(this.background);
            }
        },
        props: [
            'background',
        ]
    }
</script>
